import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { uploadButton as TEXT } from 'locales/en';

import Modal from 'components/Modal';

const AdyenUploadedDocument = ({ doc, onDeleteDocument }) => {
  const [isOpen, setIsOpen] = useState(false);

  const _onDeleteFile = async () => {
    setIsOpen(false);

    if (onDeleteDocument) {
      onDeleteDocument(doc.defenseDocumentTypeCode);
    }
  };

  return (
    <div className="w-full" key={doc.defenseDocumentTypeCode}>
      <div
        className="card inline-flex w-full justify-between bg-white px-7 py-4"
        data-testid="file-info"
      >
        <div className="pr-24">
          <FontAwesomeIcon icon={['far', 'file']} size="sm" />
          <p className="ml-5 inline-block text-xs font-bold text-javelin-gray-dark">
            {doc.defenseDocumentTypeCode}
          </p>
        </div>
        <div>
          <FontAwesomeIcon
            icon={['far', 'trash-alt']}
            size="sm"
            className="cursor-pointer text-javelin-gray-light"
            onClick={() => setIsOpen(true)}
            data-testid="delete-icon"
          />
        </div>
      </div>

      <Modal
        isOpen={isOpen}
        title={TEXT.adminModalTitle}
        onCancel={() => setIsOpen(false)}
        onConfirm={_onDeleteFile}
      />
    </div>
  );
};

export default AdyenUploadedDocument;
